import { AnalyticalExaminationType } from '@dreryk/drerykweb-medical-dictionaries-api';

import { createNumberSchema, createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { ReferralToAnalyticalExaminationFormBean } from './ReferralToAnalyticalExaminationForm/ReferralToAnalyticalExaminationForm.types';

const analyticalExaminationTypeSchema = createObjectSchema<AnalyticalExaminationType>({
   id: createNumberSchema(),
   code: createStringSchema(),
   name: createStringSchema(),
});

export const referralToAnalyticalExaminationDraftSchema = createObjectSchema<ReferralToAnalyticalExaminationFormBean>({
   additionalInformation: createStringSchema().nullable(),
   analyticalExaminationTypes: analyticalExaminationTypeSchema.array(),
}).strict();
